export default __webpack_public_path__ + "static/media/Aldrich-Regular.75395156.ttf";